import { useEffect } from "react";
import { styles } from "./sostaStyles";

export function useSostaStyles() {
  useEffect(() => {
    let el = document.getElementById("__sosta_styles");
    if (!el) {
      el = document.createElement("style");
      el.id = "__sosta_styles";
      document.head.appendChild(el);
    }
    el.textContent = styles;
  }, []);
}
